module.exports = __webpack_public_path__ + "img/Light Brightness.9e4ab950.png";